export async function loadPriceSectionData({
  stationId,
  displayPlannedPrices,
  displayShop2000Prices,
  transformPlannedPricesData,
  onPlannedLoaded,
  onShopLoaded,
  onError,
}) {
  const [plannedResult, shopResult] = await Promise.allSettled([
    displayPlannedPrices({ station_id: stationId }),
    displayShop2000Prices({ station_id: stationId }),
  ]);

  if (plannedResult.status === "fulfilled") {
    onPlannedLoaded?.(transformPlannedPricesData(plannedResult.value));
  } else {
    onError?.("planned", plannedResult.reason);
  }

  if (shopResult.status === "fulfilled") {
    onShopLoaded?.(shopResult.value);
  } else {
    onError?.("shop2000", shopResult.reason);
  }
}
